import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          lighten2: "#0E55AD",
          base: "#0D4EA0",
          darken2: "0C4894",
        },
        secondary: {
          base: "#FC0",
          darken1: "#ffa600",
          darken2: "#E58600",
        },
        grey: {
          lighten4: "#D9D9D9",
          base: "#1E1E1E",
        },
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    iconfont: "fa",
  },
});
